import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-circle",
  templateUrl: "./med-icon-circle.component.html",
})
export class MedIconCircleComponent extends SvgMixinComponent {}
